import React from 'react'

const CommentIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M3 4.5h18A1.5 1.5 0 0 1 22.5 6v11.25a1.5 1.5 0 0 1-1.5 1.5h-5.937l-2.531 2.48a.75.75 0 0 1-1.057-.008l-2.46-2.472H3a1.5 1.5 0 0 1-1.5-1.5V6A1.5 1.5 0 0 1 3 4.5zm9.014 15.137l2-1.959a1.5 1.5 0 0 1 1.049-.428H21V6H3v11.25h6.016c.4 0 .782.16 1.063.442l1.935 1.945zM7.125 12.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zm4.75 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zm5 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z' />
  </svg>
)

export default CommentIcon
